import { SearchAutocompleteProps } from "@made-people/blueprint-search";

export const SearchAutocomplete: SearchAutocompleteProps = {
  typeOfCard: "product",
  heading: {
    heading: "Search",
  },
};
